export const referralOptions = [
  {
    value: 'false',
    label: {
      children:
        'For scans performed in the US, at no additional charge to me, I authorize an independent health care provider, including without limitation, a nurse practitioner, belonging to an external network to perform an appropriateness review. For scans performed in Canada, at no additional charge to me, I authorize an independent health care provider, including without limitation, a nurse practitioner,  belonging to an external network to review my information and to order my test. (recommended)',
    },
  },
  {
    value: 'true',
    label: {
      children:
        'For services performed in either the US or Canada, I already have a written referral from my doctor, chiropractor, or a nurse practitioner.',
    },
  },
];
